import React from 'react'
import { TasksList } from './list/page'

export const NewYear2026TasksPage = () => {
  return <TasksList />
}
